import type { GetObligationByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetObligationByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetObligationByIdArgs = {
  id: string;
};

export const useLazyGetObligationById = createLazyQueryHook<
  UseLazyGetObligationByIdArgs,
  GetObligationByIdResponseRow[],
  GetObligationByIdQuery
>({
  trpcQuery: (client, { id }) =>
    client.frontend.obligation.getById.query({ id }),
  mapTrpcDataToGraphQL: (data) => ({ obligation: data || [] }),
  graphqlDocument: GetObligationByIdDocument,
  graphqlVariables: ({ id }) => ({ _eq: id }),
});
